import qs from 'query-string'

import type { DepartementsParamsDto, GouvCityDto, GouvDepartmentDto } from '../types'

const API_GEO = 'https://geo.api.gouv.fr'

export const locationService = {
  async fetchDepartment(code: string) {
    return await fetchJson<GouvDepartmentDto>(
      'GET', `${API_GEO}/departements/${code}`, null, null, null, 'same-origin',
    )
  },
  async fetchDepartments(params: DepartementsParamsDto) {
    const url = `${API_GEO}/departements?${qs.stringify(params)}`
    return await fetchJson<GouvDepartmentDto[]>('GET', url, null, null, null, 'same-origin')
  },
  async fetchCities(name: string, limit = 15) {
    const url = `${API_GEO}/communes?nom=${name}&fields=departement,nom,code,centre`
    const data = await fetchJson<GouvCityDto[]>('GET', url, null, null, null, 'same-origin')
    return data?.filter((_, k) => k < limit) ?? []
  },
  fetchCity(code: string) {
    return fetchJson<GouvCityDto>(
      'GET', `${API_GEO}/communes/${code}?fields=departement,nom,code,centre`, null, null, null, 'same-origin',
    )
  },
}
